import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=8e59b710&"
import script from "./error-page.vue?vue&type=script&lang=js&"
export * from "./error-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/galexp/development/web/educraft-vue-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e59b710')) {
      api.createRecord('8e59b710', component.options)
    } else {
      api.reload('8e59b710', component.options)
    }
    module.hot.accept("./error-page.vue?vue&type=template&id=8e59b710&", function () {
      api.rerender('8e59b710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/error-page.vue"
export default component.exports